import React from 'react';
import Head from 'next/head';
import { Container, Row, Col } from 'react-bootstrap';
import Link from 'next/link';
import PublicTopNavigation from 'components/Navigation/PublicTopNavigation';
import PublicFooter from 'components/Footer/PublicFooter';
import { translate as t } from 'utils/helpers';
import useLang from 'context/LanguageContext';
import routes from 'utils/routes';
import styles from '../[podcast-name]/privacy-policy/InfoPages.module.scss';

const UnauthorizedPage = () => {
  const { lang } = useLang();
  return (
    <div className="page nosidebar">
      <Head>
        <title>Unauthorized | Mumbler</title>
        {/*<link rel="icon" href="/favicon.png" />*/}
      </Head>

      <main className="main">
        <Container className="full mobile-full" fluid>
          <Row className={styles.mainRow}>
            <Col lg={12} className={styles.primary}>
              <PublicTopNavigation lang={lang} />

              <Container
                className={`${styles.contentWrap} full mobile-full`}
                fluid>
                <Container
                  className={`${styles.contentChild} ${styles.errorContent} ${styles.mainError} wider`}>
                  <span className={`${styles.backgroundText}`}>
                    {t(lang, 'helpError')('error')}
                  </span>
                  <img src="/error.svg" alt="Error" className="img-fluid" />
                  <h1 className={styles.sectionHeading}>
                    {t(lang, 'helpError')('somethingWentWrong')}
                  </h1>

                  <p>
                    {t(
                      lang,
                      'helpError',
                    )(
                      'youAreNotAuthorizedToVisitThisPageFromYourMumblerAccount',
                    )}
                    <br />
                    {t(lang, 'helpError')('ifYouLandedHereByMistake')}{' '}
                    {/* <Link > */}
                      <a href={routes.home(lang)}>{t(lang, 'helpError')('goToHome')}</a>
                    {/* </Link> */}
                    .
                  </p>
                </Container>
              </Container>

              <PublicFooter lang={lang} />
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
};

// UnauthorizedPage.propTypes = { lang: PropTypes.oneOf(supportedLanguages) };

export default UnauthorizedPage;
